import { render, staticRenderFns } from "./merchant_list.vue?vue&type=template&id=fabc76ee&"
import script from "./merchant_list.vue?vue&type=script&lang=js&"
export * from "./merchant_list.vue?vue&type=script&lang=js&"
import style0 from "./merchant_list.vue?vue&type=style&index=0&id=fabc76ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports